import { receiveList } from '@/services/api';

export default {
  namespace: 'receiveList',
  state: {
    daily: [],
    weekly: [],
    charmDaily: [],
    charmWeekly: [],
    totalNum: 0
  },
  reducers: {
    updateList(state, { payload }) {
      return {
        ...state,
        totalNum: payload.totalNum
      };
    },
    updateContributionList(state, { payload }) {
      return {
        ...state,
        [payload.key]: payload.value
      };
    }
    // updateCharmList(state, { payload }) {
    //   return {
    //     ...state,
    //     [payload.key]: payload.value
    //   };
    // }
  },
  effects: {
    *receiveList({ payload }, { call, put }) {
      const { data } = yield call(receiveList, payload);
      // yield put({
      //   type: 'updateCharmList',
      //   payload: {
      //     key: payload.type % 2 !== 0 ? 'charmDaily' : 'charmWeekly',
      //     value: data?.rankList?.sort((a, b) => a.position - b.position) || []
      //   }
      // });

      const keyMap = {
        1: 'daily',
        2: 'weekly',
        3: 'charmDaily',
        4: 'charmWeekly'
      };
      console.log('data', data);
      yield put({
        type: 'updateList',
        payload: {
          totalNum: data?.total || 0
        }
      });
      yield put({
        type: 'updateContributionList',
        payload: {
          key: keyMap[payload.type],
          value: data?.rankList?.sort((a, b) => a.position - b.position) || []
        }
      });
    }
  }
};
